module.exports = __webpack_public_path__ + "img/swiper9.7ea6da86.png";